import React from 'react';
import { Provider } from './Provider';
import Inner from './Inner';
import { PageLoading } from '../Loading';

const Wrapper = ({children, onSubmit, onChange, data, waitForData, disabled, closeModalOnSubmit, goBackOnSubmit, afterSubmit, afterError, layout, restoreDataOnConditionalChange, conditionalDependencies}) => {
    if (waitForData && !data) {
        return waitForData === true ? <PageLoading /> : waitForData;
    }

    return <Provider
        {...{data, disabled, closeModalOnSubmit, goBackOnSubmit, afterSubmit, afterError, onChange, restoreDataOnConditionalChange, conditionalDependencies, layout: layout ?? 'vertical'}}
    >
        <Inner onSubmit={onSubmit} layout={layout ?? 'vertical'}>
            {children}
        </Inner>
    </Provider>
}

export default Wrapper;
